module.exports = __webpack_public_path__ + "static/media/ic-column-remove.1f7825ca.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/table-icons/ic-column-remove.svg
// module id = 821
// module chunks = 17